import { BadgeCheck } from "lucide-react";
import { Section, Reveal, Field } from "@/components/primitives";
import { credentials } from "@/config";

export default function Credentials() {
  return (
    <Section id="credentials" tone="noir" compact className="border-y border-cream/8">
      <Reveal className="mx-auto max-w-4xl text-center">
        <h2 className="font-serif text-xl text-cream sm:text-2xl">{credentials.headline}</h2>
        <div className="mx-auto mt-7 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2">
          {credentials.items.map((c) => (
            <div key={c.issuer} data-testid="credential-badge" className="card flex items-center gap-3.5 rounded-xl px-5 py-4 text-left">
              <BadgeCheck className="h-5 w-5 shrink-0 text-gold" />
              <div className="min-w-0">
                <p className="text-sm font-medium text-cream">{c.issuer}</p>
                <p className="mt-0.5 text-xs text-gray2"><Field value={c.name} fallback="Certification name on request" /></p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-6 text-sm font-light italic text-gray2/80">{credentials.line}</p>
      </Reveal>
    </Section>
  );
}
